export default __webpack_public_path__ + "static/media/calculo-de-comisiones.bd666500.png";